module.exports = __webpack_public_path__ + "static/media/defaultfile.3fe31cc8.svg";